<script lang="ts">
  import { api } from '../lib/api';

  let { onlogin, dev }: { onlogin: () => void; dev: boolean } = $props();
  let username = $state('');
  let password = $state('');
  let error = $state<string | null>(null);
  let busy = $state(false);

  async function submit(e: Event) {
    e.preventDefault();
    busy = true;
    error = null;
    try {
      await api.post('/api/login', { username, password });
      onlogin();
    } catch (err) {
      error = (err as Error).message;
    } finally {
      busy = false;
    }
  }
</script>

<div class="wrap">
  <form class="panel" onsubmit={submit}>
    <h1>Visual Talkback</h1>
    <label>Username <input autocomplete="username" autocapitalize="off" bind:value={username} required /></label>
    <label>Password <input type="password" autocomplete="current-password" bind:value={password} required /></label>
    {#if error}<p class="error">{error}</p>{/if}
    <button class="primary" disabled={busy}>Log in</button>
    {#if dev}
      <p class="muted small">Dev mode logins: admin/admin · director/director · operator/operator · viewer/viewer</p>
    {/if}
    {#if !window.isSecureContext}
      <p class="error">This page is not secure: the microphone will not work. Open it via https://</p>
    {/if}
  </form>
</div>

<style>
  .wrap { min-height: 100vh; display: grid; place-items: center; padding: 16px; }
  form { width: min(420px, 100%); display: flex; flex-direction: column; gap: 14px; }
  .small { font-size: 0.8rem; }
  button { padding: 14px; font-size: 1.1rem; }
</style>
